import { isTruthy } from '@fabric-app/utils/guards';
import { getFileChunk } from './getFileChunk.js';
import { executeXHRUpload } from './executeXHRUpload.js';
import { executeFetchUpload } from './executeFetchUpload.js';
import { executeNativeUpload } from './executeNativeUpload.js';
import { getToDesktopStreamChunk } from './getToDesktopStreamChunk.js';

const executeUploadRequest = async (options) => {
  const { data, chunk, onProgress, abortSignal } = options;
  if (!data.available) {
    throw new Error("File is not available");
  }
  const signal = abortSignal || new AbortController().signal;
  const startTime = Date.now();
  const headers = options.headers ? Object.fromEntries(Object.entries(options.headers).filter(([, value]) => isTruthy(value))) : {};
  const onProgressCallback = (loaded, total) => {
    const progress = loaded / total * 100;
    const timeElapsed = Date.now() - startTime;
    const uploadSpeed = loaded / (1024 * 1024) / (timeElapsed / 1e3);
    onProgress?.(progress, uploadSpeed);
  };
  if (data.type === "file" || data.type === "todesktop-stream") {
    let toUpload;
    if (data.type === "file") {
      toUpload = chunk ? getFileChunk(data.file, chunk.index, chunk.size) : data.file;
    } else {
      const chunkIndex = chunk?.index ?? 0;
      const chunkSize = chunk ? chunk.size : data.file.size;
      toUpload = await getToDesktopStreamChunk(data.stream, data.file.size, data.file.mimeType, chunkIndex, chunkSize);
    }
    options.onChunkBegin?.(toUpload, chunk?.index ?? 0, chunk?.size ?? data.file.size);
    if (typeof XMLHttpRequest !== "undefined") {
      return executeXHRUpload({
        method: options.method,
        url: options.url,
        headers,
        onProgress: onProgressCallback,
        abortSignal: signal,
        file: toUpload
      });
    }
    return executeFetchUpload({
      method: options.method,
      url: options.url,
      headers,
      onProgress: onProgressCallback,
      abortSignal: signal,
      file: toUpload
    });
  } else {
    return executeNativeUpload({
      method: options.method,
      url: options.url,
      headers,
      onProgress,
      abortSignal: signal,
      data,
      chunk
    });
  }
};

export { executeUploadRequest };
//# sourceMappingURL=executeUploadRequest.js.map
